// extracted by mini-css-extract-plugin
export default {"container":"PromotedActionsMenuEventCard-module__container___3jHhA"};